import styled from '@emotion/styled'
import { Embed } from '../../../../publication/Embed/Embed'

export const PNEmbed = styled(Embed)({
    margin: 0,
})
